/************************************
MODULE:         new layout

*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function($) {

    function init() {
        initTabs();
        initSlides();
        initSubmitButton();
        initSelectTitleDropdown();
        $(window).off('newlayout:init');
        $(window).on('newlayout:init', initTabs);
        $(window).on('newlayout:init', initSlides);
        $(window).on('newlayout:init', initSubmitButton);
        $(window).on('newlayout:init', initSelectTitleDropdown);
    }

    function initTabs() {
        var tabLinks = $('.js-tab-link-newlayout').not('.js-inited');
        if (!tabLinks.length) {
            return;
        }
        tabLinks.addClass('js-inited');
        tabLinks.eq(0).addClass('selected');
        var tabSlides = $('.js-slide-newlayout');
        tabSlides.not(":first").addClass('is-hidden');

        tabLinks.off('click');
        tabLinks.on('click', { tabLinks: tabLinks }, tabLinkClick);
    }

    function tabLinkClick(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var tabId = $(this).attr('data-tab-id');
        if (!tabId) return;

        e.data.tabLinks.removeClass('selected');

        $(this).addClass('selected');

        var tabSlides = $('.js-slide-newlayout');
        tabSlides.hide();
        tabSlides.addClass('is-hidden');
        tabSlides.filter('[data-tab-id="' + tabId + '"]').show().removeClass('is-hidden');

        $('.start-slide').slick('refresh');
    }

    function initSubmitButton() {
        var btnSubmits = $('a.js-btn-newlayout').not('a.js-inited');
        if (!btnSubmits.length) {
            return;
        }
        btnSubmits.addClass('js-inited');
        console.log('newlayout - initialized');

        addClassToBody();

        btnSubmits.on('click', { textInput: initTextInput() }, btnSubmitClick);

        for (var i = 0; i < btnSubmits.length; i++) {
            var btnEventList = $._data(btnSubmits[i], "events");
            // move latest added events to be the first
            btnEventList.click.unshift(btnEventList.click.pop());
        }
    }

    function btnSubmitClick(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var link = $(this);

        if (link.hasClass('js-clicked')) {
            e.stopImmediatePropagation();
            return;
        }

        var selectedDurationRadio = $('input[name=duration]:checked');
        if (selectedDurationRadio.length) {
            link.attr('data-enquiry-howlong', selectedDurationRadio.val());
        }

        var visibleSlide = $(".js-slide-newlayout:not(.is-hidden) .slick-current.slick-active");
        if (visibleSlide.length) {
            var paramsCopy = getAllDataEnquiryAndTrackingParams(visibleSlide);
            for (var parametr in paramsCopy) {
                link.attr(parametr, paramsCopy[parametr]);
            }
        }

        var selectTitle = $('select#select-title option:selected');
        if (selectTitle.length) {
            link.attr('data-enquiry-title', selectTitle.val());
        }

        var isDataValid = true;
        var textInput = e.data.textInput;
        if (textInput != null) {

            var i = 0;
            while (textInput[i]) {
                if (textInput[i].hasAttribute('validationExpression')) {

                    var expression = textInput[i].getAttribute('validationExpression');
                    if (expression != null && !(new RegExp(expression).test(textInput[i].value))) {
                        e.stopImmediatePropagation();
                        $('div.content-container').addClass('is-error');
                        $('div.message').show();
                        isDataValid = false;
                    } else {
                        $('div.content-container').removeClass('is-error');
                        $('div.message').hide();
                    }
                }

                link.attr('data-enquiry-' + textInput[i].getAttribute('data-name'), textInput[i].value);
                i++;
            }
            textInput.focus();
        }

        if (isDataValid) {
            link.addClass('js-clicked');
        }

        if (link.hasClass('js-btn-newlayout-submit-quote')) {
            $(link).trigger('beforesubmit');

            link.trigger('forms:submitQuote', [link.attr('href'), '']);
        }
    }

    function initTextInput() {
        var textInput = $('input.js-input').not('js-inited');
        if (!textInput.length) {
            return null;
        }

        textInput.addClass('js-inited');

        textInput.on('input', function() {
            if ($(this).val() !== '') {
                $('.button_large').prop('disabled', false);
                $(' a.mobile-next-step').removeClass('disabled');

                if ($('div.content-container').hasClass('is-error')) {
                    $('div.content-container').removeClass('is-error');
                    $('div.message').hide();
                }
            } else {
                $('.button_large').prop('disabled', true);
                $(' a.mobile-next-step').addClass('disabled');
            }
        });

        return textInput;
    }

    function initSelectTitleDropdown() {
        var dropDown = $('select#select-title').not('.js-inited');
        if (!dropDown.length) {
            return;
        }
        dropDown.addClass('js-inited');

        dropDown.on('change', function () {
            if ($(this).val() === '') {
                $('.mobile-next-step').removeClass('show');
                $('.select-container').removeClass('smaller-width');
                $('.button_large').prop('disabled', true);
            }
            else {
                $('.select-container').addClass('smaller-width');
                $('.mobile-next-step').addClass('show');
                $('.button_large').prop('disabled', false);
            }
        });
    }

    function initSlides() {
        var tabSlides = $('.js-slide-newlayout').not('.js-inited');
        if (!tabSlides.length) {
            return;
        }
        tabSlides.each(function(i, container) {
            markSingleSlideCarousel(container);
        });

        tabSlides.addClass('js-inited');

        tabSlides.hide();
        tabSlides.eq(0).show();

        var initialSlide = 0;
        if (tabSlides[0].getAttribute('data-js-initial-size-slide') != null) {
            initialSlide = parseInt(tabSlides[0].getAttribute('data-js-initial-size-slide'));
        }

        require.ensure([], function () {
            var slick = require('slick');

            // carousel
            $('.js-slide-newlayout .start-slide').slick({
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                initialSlide: initialSlide
            });

        }, 'slick');

    }

    function markSingleSlideCarousel(container) {
        const slideLength = container.querySelectorAll('.js-slide').length;
        if (slideLength === 1) {
            container.classList.add('is-single');
        }
    }

    function addClassToBody() {
        if (!$('body').hasClass('bg_new-layout')) {
            $('body').addClass('bg_new-layout');
        }
    }

    function getAllDataEnquiryAndTrackingParams(element) {
        var dataAttributes = element.data(),
            settings = {};

        for (var attr in dataAttributes) {
            if (attr.indexOf('enquiry') === 0) {
                settings['data-' + attr.toLowerCase()] = dataAttributes[attr];
            }

            if (attr.indexOf('tracking') === 0) {
                settings['data-tracking-' + attr.substr("tracking".length).toLowerCase()] = dataAttributes[attr];
            }
        }

        return settings;
    }

    return {
        init: init
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.newlayout.js
 ** module id = 46
 ** module chunks = 24
 **/